<template>
  <div class="new-subproject-dialog-wrap">
    <el-dialog
      class="new-subproject-dialog"
      :visible.sync="dialogShow"
      destroy-on-close
      :before-close="handleClose"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div class="new-subproject-dialog-top">
        <p class="tit">新建子项目</p>
        <div class="icon-wrap">
          <i class="icon iconfont iconicon_close activeIconHover" @click="handleClose"></i>
        </div>
      </div>

      <div class="new-subproject-dialog-con">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          size="large"
        >
          <el-form-item label="项目名称" prop="title">
            <el-input v-model="ruleForm.title" placeholder="请输入项目名称"  class="has-color">
              <template slot="prefix">
                <ColorControl @change="colorChange" v-if="dialogShow"></ColorControl>
              </template>
            </el-input>
          </el-form-item>

          <el-form-item label="项目分类" prop="project_depart_id">
            <el-cascader
              :options="classifyOptions"
              placeholder="请选择项目分类"
              @change="handleChosClassify"
            ></el-cascader>
          </el-form-item>

          <el-form-item label="项目管理员" prop="member">
            <el-cascader
              :options="taskMemberlist"
              placeholder="请选择项目管理员"
              @change="handleChosMember"
            ></el-cascader>
          </el-form-item>

          <el-form-item label="项目描述" prop="content">
            <el-input type="textarea" v-model="ruleForm.content"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div class="btn-wrap dialog-footer">
        <span class="cancel text-btn-active" @click="handleClose">取消</span>
        <wf-button type="primary" @click="handleAdd">创建</wf-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
//api
import api from '@/services/api/home/home'
import departmentApi from '@/services/api/department/department'
import ColorControl from '@/components/colorControl'
export default  {
  components: {
    ColorControl
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    crossPojectId: {
      type: Number,
      default: null
    }
  },
  computed: {
    ...mapState('department/department', {
      departmentgroup: state => state.projectList.departmentgroup
    }),
    taskMemberlist () {
      let arr = []
      if (this.departmentgroup?.length) {
        const _list = this.departmentgroup
        for (let i = 0, len = _list.length; i < len; i++) {
          arr.push({
            value: _list[i].depart_id,
            label: _list[i].name,
            children: []
          })
          for (let j = 0, len2 = _list[i].member.length; j < len2; j++) {
            arr[i].children.push({
              value: _list[i].member[j].uid,
              label: _list[i].member[j].realname
            })
          }
        }
      }
      return arr
    }
  },
  data() {
    return {
      ruleForm: {
        cross_project_id: null,
        title: '',
        project_depart_id: '', //项目id
        project_list_id: '', //业务id
        member: [],
        content: '',
        background_color: '',
        background_text: ''
      },
      projectId: null,
      classifyOptions: [],
      memberOptions: [],
      rules: {
        title: [
          { required: true, message: '请输入项目名称', trigger: 'blur' },
        ],
        project_depart_id: [
          { required: true, message: '请选择项目分类', trigger: 'change' },
        ],
        member: [
          { required: true, message: '请选择项目管理员', trigger: 'change' },
        ]
      }
    }
  },
  watch: {
    dialogShow(val) {
      if (val) {
        if (!this.classifyOptions.length) {
          this.selectInit() //获取项目分类列表
        }
        // if (!this.memberOptions.length) {
        //   this.getMembers() //获取所有成员列表
        // }
      } else {
        this.ruleForm = {
          cross_project_id: null,
          title: '',
          project_depart_id: '', //项目id
          project_list_id: '', //业务id
          member: [],
          content: ''
        }
      }
    }
  },
  methods: {
    ...mapActions("project/project", ["getDepartmentProjectfolder"]),
    selectInit() {
      this.getDepartmentProjectfolder().then((res) => {
        const _list = res.ProjectList;
        for (let i = 0, len = _list.length; i < len; i++) {
          this.classifyOptions.push({
            value: _list[i].department_category_id,
            label: _list[i].department_category_name,
            children: [],
          });
          const data = _list[i].projectlist;
          // let k = i + 1
          for (let key in data) {
            this.classifyOptions[i].children.push({
              value: data[key].project_list_id,
              label: data[key].project_list_title,
            });
          }
        }
      });
    },
    async getMembers() {
      const res = await departmentApi.getDepartmentUser({ working_status: '在职' })
      if (res) {
        const _list = res.departmentgroup
        for (let i = 0, len = _list.length; i < len; i++) {
          this.memberOptions.push({
            value: _list[i].depart_id,
            label: _list[i].name,
            children: []
          })
          for (let j = 0, len2 = _list[i].member.length; j < len2; j++) {
            this.memberOptions[i].children.push({
              value: _list[i].member[j].uid,
              label: _list[i].member[j].realname
            })
          }
        }
      }
    },
    handleChosClassify(val) {
      this.ruleForm.project_depart_id = val[0]
      this.ruleForm.project_list_id = val[1]
    },
    handleChosMember(val) {
      this.ruleForm.member = [val[1]]
    },
    handleClose() {
      this.$refs['ruleForm'].resetFields()
      this.$emit('handleClose', 'newSubprojectDialogShow')
    },
    handleAdd() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          this.ruleForm.cross_project_id = this.crossPojectId

          const res = await api.createSubproject(this.ruleForm)
          if (res) {
            this.$message({
              message: '创建成功',
              type: 'success'
            })
            this.$emit('update')
          }
        }
      });
    },
    colorChange(val) {
      let {background_color, background_text} = val
      this.ruleForm.background_color = background_color
      this.ruleForm.background_text = background_text
    }
  }
}
</script>

<style lang="scss">
.new-subproject-dialog-wrap {
  .el-dialog {
    width: 590px;
    .el-dialog__header {
      padding: 0 !important;
    }
    .el-dialog__body {
      padding: 0 !important;
      .new-subproject-dialog-top {
        width: 100%;
        padding: 15px 24px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid  rgba(231,232,237,0.6);
        .tit {
          font-size: 16px;
          font-weight: 500;
          color: #0D1F3C;
        }
        .icon-wrap {
          display: flex;
          i {
            font-size: 16px;
            margin-left: 26px;
            cursor: pointer;
          }
        }
      }
      .new-subproject-dialog-con {
        padding-top: 30px;
        .el-form {
          .el-form-item {
            width: 100%;
            margin-bottom: 32px;
            padding: 0 24px;
            box-sizing: border-box;
            .el-form-item__content {
              line-height: 32px;
            }
            label {
              width: 100%;
              text-align: left;
              margin-bottom: 8px;
              font-size: 14px;
              font-weight: 400;
              color: #0D1F3C;
              line-height: 20px;
            }
            .el-select,
            .el-cascader {
              width: 100%;
            }
            input {
              background: rgba(32, 32, 32, 0.04);
              border-radius: 4px;
              border: 1px solid #E5E6E8;
            }
            textarea {
              height: 130px;
              background: rgba(32, 32, 32, 0.04);
              border-radius: 4px;
              border: 1px solid #E5E6E8;
            }
            .el-input__icon {
              line-height: 32px;
            }
            .has-color .el-input__inner {
              padding-left: 70px;
            }
            .color-control {
              border-right: 1px solid rgba(32, 32, 32, 0.16);
              padding-right: 8px;
            }
            .color-control,.color-control .el-dropdown-link, .color-control .el-dropdown, .color-control .el-dropdown-link {
              height: 100%;
            }
            .el-input__prefix {
              left: 8px;
            }
            .el-input__prefix .color-control .el-dropdown {
              .el-dropdown-link img{
                width: 20px;
                height: 20px;
                border-radius: 4px;
              }
            }
          }
        }
          .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before,
          .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:before {
              display: none;
          }
          .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label::after,
          .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label::after {
              content: '*';
              color: #F56C6C;
              margin-left: 4px;
          }
      }
      .btn-wrap {
        width: 100%;
        height: 54px;
        padding: 11px 24px;
        box-sizing: border-box;
        border-top: 1px solid rgba(231,232,237,0.6);
        display: flex;
        justify-content: flex-end;
        .wf-button {
          width: 76px;
          margin-left: 24px;
        }
      }
    }
  }

}
</style>
